export default __webpack_public_path__ + "static/media/cp_geo_mg.ff01ba98.svg";